var exports = {
  "kL": "IpAuthorizationScreen.module__container___d2h3em",
  "Kk": "IpAuthorizationScreen.module__icon___d2h3em",
  "DD": "IpAuthorizationScreen.module__title___d2h3em",
  "h_": "IpAuthorizationScreen.module__description___d2h3em",
  "o1": "IpAuthorizationScreen.module__actions___d2h3em",
};

module.exports = exports;
